module.exports = __webpack_public_path__ + "static/media/azet-logo-no-text-blue.ef3acee9.png";